
<ul class="navigation__tabs" role="tablist">
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'common'"
      [ngClass]="{'navigation__tab__link_active': 'common' === current_path}">
      Основное
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'advanced'"
      [ngClass]="{'navigation__tab__link_active': 'advanced' === current_path}">
      Дополнительно
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'conditions'"
      [ngClass]="{'navigation__tab__link_active': 'conditions' === current_path}">
      Реализация
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'layout'"
      [ngClass]="{'navigation__tab__link_active': 'layout' === current_path}">
      Планировки
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'floors'"
      [ngClass]="{'navigation__tab__link_active': 'floors' === current_path}">
      Поэтаж.
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'images'"
      [ngClass]="{'navigation__tab__link_active': 'images' === current_path}">
      Изображения
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'proprietors'"
      [ngClass]="{'navigation__tab__link_active': 'proprietors' === current_path}">
      Собственники
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <!--<li class="navigation__tab">-->
  <!--<a class="navigation__tab__link" href="javascript: void(0)" (click)="current_path = 'operations'"-->
  <!--[ngClass]="{'navigation__tab__link_active': 'operations' === current_path}">-->
  <!--Операции-->
  <!--<span class="navigation__tab__link_active__slide"></span>-->
<!--</a>-->
<!--</li>-->
</ul>

@if ('common' === current_path) {
  <app-flat-common [flatId]="flatId"></app-flat-common>
}
@if ('advanced' === current_path) {
  <app-flat-advanced [flatId]="flatId"></app-flat-advanced>
}
@if ('conditions' === current_path) {
  <app-flat-conditions [flatId]="flatId"></app-flat-conditions>
}
@if ('layout' === current_path) {
  <app-flat-layout [flatId]="flatId"></app-flat-layout>
}
@if ('floors' === current_path) {
  <app-flat-floors [flatId]="flatId"></app-flat-floors>
}
@if ('images' === current_path) {
  <app-flat-images [flatId]="flatId"></app-flat-images>
}
@if ('proprietors' === current_path) {
  <app-flat-proprietors [flatId]="flatId"></app-flat-proprietors>
}

@if ('operations' === current_path) {
  <app-flat-operations></app-flat-operations>
}
